<template>
  <div class="config-list-panel">
    <div class="panel-title h-outer-border around-4 bw2 bz0 h-bg brown-2">
      <div class="flex flex-grow">
        <div v-click-sound-button
             class="label"
             :class="activeConfig === CONFIG_TP.PRIVATE ? 'active' : ''"
             @click="selectConfigType(CONFIG_TP.PRIVATE)">
          🧑我的配置
        </div>
        <div v-click-sound-button
             class="label"
             :class="activeConfig === CONFIG_TP.PRIVATE ? '' : 'active'"
             @click="selectConfigType(CONFIG_TP.PUBLIC)">
          🏠配置大厅
        </div>
      </div>
      <div class="tools">
        <div v-click-sound-button class="btn" @click="handleBuildConfig">🔧创建配置</div>
      </div>
    </div>

    <div class="config-list">
      <template v-for="(item, index) in configList">
        <div class="config-item h-outer-border around-4 bw3 bz0 h-bg brown-2"
             :class="{ selected: index === selectedIndex }">
          <div class="config-content">
            <div class="config-head flex flex-col justify-between">
              <p class="title flex items-center">{{ item.title }}</p>
              <div class="buttons flex-shrink-0">
                <div class="h-line separator"></div>
                <div class="flex justify-between" style="height: 16px;">
                  <template v-if="activeConfig === CONFIG_TP.PRIVATE">
                    <div v-click-sound-button class="h-btn btn-text btn-text-white ls-1" @click="handleDelete(item)">
                      删除
                    </div>
                    <div v-click-sound-button class="h-btn btn-text btn-text-white ls-1" @click="handleModify(item)">
                      修改
                    </div>
                  </template>
                  <template v-else>
                    <div class="white pt-1">{{ item.nick }}</div>
                  </template>

                </div>
              </div>
            </div>
            <div class="h-line separator vertical"></div>
            <ConfigGlance :config="JSON.parse(item.config)"></ConfigGlance>
            <div class="h-line separator vertical"></div>
          </div>
          <!-- 功能按钮 -->
          <div class="config-buttons pr-5 flex">
            <div class="flex flex-col justify-center">
              <button class="h-btn normal small" v-click-sound-button @click="handleApply(item)">
                <span>选择</span>
              </button>
              <div v-click-sound-button
                   v-if="activeConfig === CONFIG_TP.PRIVATE"
                   style="overflow: visible;"
                   class="mt-5 h-btn btn-text btn-text-white ls-1 center h-title nowrap"
                   :data-title="item.public ? '点击取消共享' : '共享配置'"
                   @click="handleShare(item)">
                {{ item.public ? '已共享' : '共享' }}
              </div>

            </div>
          </div>
        </div>
        <div v-if="index !== configList.length - 1" class="h-line separator"></div>
      </template>
    </div>

    <!-- 分页 -->
    <div class="pager-wrapper h-outer-border around-4 bw2 bz0 h-bg brown-2 flex justify-end items-center">
      <span class="total mr-15">共 {{ pager.total }} 条</span>
      <div class="pager">
        <div v-click-sound-button class="btn-page page-prev" @click="handlePrevPage">上一页</div>
        <div class="current">{{ pager.page + 1 }} / {{ maxPage + 1 }}</div>
        <div v-click-sound-button class="btn-page page-prev" @click="handleNextPage">下一页</div>
      </div>
    </div>

    <footer>
      <button v-click-sound-button
              class="h-btn cancel btn-border"
              @click="handleClose">
      </button>
    </footer>
  </div>
</template>

<script>
  import API from '@js/api'
  import ConfigGlance from './config-glance'

  const CONFIG_TP = {
    PRIVATE: 0,
    PUBLIC: 1,
  }

  export default {
    name: 'panel-list',

    data () {
      return {
        CONFIG_TP,
        activeConfig: CONFIG_TP.PRIVATE,
        privateConfigList: [],
        publicConfigList: [],
        privatePager: {
          page: 0,
          pageSize: 4,
          total: 0
        },
        publicPager: {
          page: 0,
          pageSize: 4,
          total: 0
        },
        loading: false,
        selectedIndex: null,
      }
    },

    computed: {
      pager () {
        return this.activeConfig === CONFIG_TP.PRIVATE ? this.privatePager : this.publicPager
      },

      configList () {
        return this.activeConfig === CONFIG_TP.PRIVATE ? this.privateConfigList : this.publicConfigList
      },

      maxPage () {
        const { pageSize, total } = this.pager
        return Math.max(0, Math.ceil(total / pageSize) - 1)
      }
    },

    mounted () {
      this.getConfigList()
    },

    methods: {
      async getConfigList () {
       if (this.activeConfig === CONFIG_TP.PRIVATE) {
         this.getPrivateConfigList()
       } else {
         this.getPublicConfigList()
       }
      },

      async getPrivateConfigList () {
        try {
          const res = await API.pkConfig.getFreeModeConfigList({
            page: this.pager.page,
            pageSize: this.pager.pageSize,
          })
          this.privatePager.total = res.total
          this.privateConfigList = res.list
        } catch (err) {
          this.$message(err)
        }
      },

      async getPublicConfigList () {
        try {
          const res = await API.pkConfig.getPublicFreeModeConfigList({
            page: this.pager.page,
            pageSize: this.pager.pageSize,
          })
          this.publicPager.total = res.total
          this.publicConfigList = res.list
        } catch (err) {
          this.$message(err)
        }
      },

      handlePrevPage () {
        const toPage = Math.max(0, this.pager.page - 1)
        if (toPage !== this.pager.page) {
          this.selectedIndex = null
          this.pager.page = toPage
          this.getConfigList()
        }
      },

      handleNextPage () {
        const toPage = Math.min(this.maxPage, this.pager.page + 1)
        if (toPage !== this.pager.page) {
          this.selectedIndex = null
          this.pager.page = toPage
          this.getConfigList()
        }
      },

      selectConfigType(type) {
        if (this.activeConfig !== type) {
          this.activeConfig = type
          this.getConfigList()
        }
      },

      handleBuildConfig () {
        this.$emit('buildConfig')
      },

      handleModify (item) {
        this.$emit('editConfig', item)
      },

      handleApply (item) {
        this.$emit('apply', {
          ...JSON.parse(item.config),
          title: item.title,
          id: item.id,
        })
      },

      async handleShare (item) {
        try {
          if (this.loading) {
            return
          }
          this.loading = true
          const message = item.public ?
            `即将取消共享配置【${ item.title }】，请确认。` :
            `即将共享配置【${ item.title }】，请确认。`
          const confirm = await this.$confirm(message)
          if (!confirm) {
            return
          }

          await API.pkConfig.shareFreeModeConfig({
            id: item.id,
            isShare: +!item.public,
          })
          this.getConfigList()
        } catch (err) {
          this.$message(err)
        } finally {
          this.loading = false
        }
      },

      async handleDelete (item) {
        try {
          if (this.loading) {
            return
          }
          this.loading = true
          const confirm = await this.$confirm(`即将删除【${ item.title }】，请确认。`)
          if (!confirm) {
            return
          }

          await API.pkConfig.deleteFreeModeConfig({
            id: item.id,
          })
          this.getConfigList()
        } catch (err) {
          this.$message(err)
        } finally {
          this.loading = false
        }
      },

      handleSelect (index) {
        this.selectedIndex = index
      },

      handleClose () {
        this.$emit('close')
      },
    },

    components: {
      ConfigGlance,
    },

  }
</script>

<style lang="stylus" scoped>
  .config-list
    margin-top 5px
    height 370px

  .pager-wrapper
    position relative
    padding 5px
    .total
      line-height 16px
      whiteText1()
    .pager
      position relative
      display flex
      line-height 16px
      font-size 12px
      .btn-page
        goldText1()
        &:hover
          opacity 1
          color $colorGold
          cursor pointer
        &:active
          opacity 1
          color darken($colorGold, 15%)
      .btn-page[disabled]
        color $colorWhite
      .current
        padding 0 10px
        whiteText1()

  .config-item
    display flex
    justify-content space-between
    align-items stretch
    padding 4px
    font-size 12px
    &:not(:last-child)
      margin-bottom 8px
    &:hover
      box-shadow 3px 3px 0 #000
      outline 1px solid $colorGold
    .config-content
      display flex
      .config-head
        position relative
        padding 0 3px
        > .title
          goldText1()
          flex-grow 1
          width 120px
          padding 3px 0
          flex-shrink 0
          line-height 15px
          font-size 12px
          font-weight bold
          letter-spacing 2px
          word-break break-word
      .buttons .h-line
        margin 2px 0
    .config-btn
      position relative
      display flex
      flex-direction column
      justify-content flex-end
      align-items center
      width 30px
      .btn
        padding 0 2px
        line-height 18px
        letter-spacing 1px
        user-select none
        color $colorGold
        opacity 0.75
        &:hover
          opacity 1
          color $colorGold
          cursor pointer
        &:active
          opacity 1
          color darken($colorGold, 15%)

  .check-box
    margin 0 5px
    display flex
    justify-content center
    align-items center
    width 24px
    height 24px
    padding 3px
    cursor pointer
    img
      max-width 100%

  .panel-title
    display flex
    align-items center
    margin-bottom 1px
    padding 2px 7px
    line-height 24px
    font-size 12px
    whiteText1()
    .label
      position relative
      flex-grow 1
      letter-spacing 1px
      whiteText1()
      &:hover
        cursor pointer
      &.active
        color $colorLightBlue

  .tools
    position relative
    padding 0 10px
    display flex
    .btn
      padding 0 2px
      line-height 24px
      letter-spacing 1px
      user-select none
      color $colorWhite
      opacity 0.75
      &:not(:last-child)
        margin-right 5px
      &:hover
        opacity 1
        color $colorWhite
        cursor pointer
      &:active
        opacity 1
        color $colorWhite
    .btn[disabled]
      color $colorWhite

  footer
    position absolute
    display flex
    justify-content space-evenly
    width calc(100% - 30px)
    left 15px
    bottom 20px
    .normal
      width 96px
      height 48px

</style>
